import React from 'react';
import PropTypes from 'prop-types';
import * as echarts from 'echarts';
import ReactEcharts from 'echarts-for-react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';


const FilteredBarChart = ({
  data, legendTitle, unitName, onEvents, selected,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const { t } = useTranslation(['translation']);
  const total = data.reduce((acc, cv) => acc + cv.value, 0);
  const generateTooltipText = (params) => {
    const { name, value } = params[0]
    return `
      ${name}<br/>
      ${t('COMMON.INTL_NUMBER', { value })} ${unitName} <br/>
      ${t('COMMON.INTL_PERCENT', { value: total ? value / total : 0 })}`
  };
  const options = {
    legend: {
      data: [{
        name: legendTitle,
        icon: 'rect',
        textStyle: {
          color: '#666C6F',
          fontSize: 15,
        },
      }],
      top: 10,
    },
    grid: {
      left: isMobile ? '35%' : '20%',
    },
    backgroundColor: 'transparent',
    yAxis: [{
      type: 'category',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#666C6F',
        fontSize: 12,
        fontWeight: 'bold',
        formatter: info =>
          ((info.length <= 10) ? info : `${info.substring(0, 7)}...`),
      },
      data: data.map(el => (el.name.length > 22 ? `${el.name.slice(0, 22)}...` : el.name)),
    }],
    xAxis: [{
      type: 'value',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#666C6F',
        fontSize: 12,
        fontWeight: 'bold',
        rotate: isMobile ? 30 : 0,
      },
      splitLine: {
        show: false,
      },
    }],
    tooltip: {
      backgroundColor: 'rgba(50,50,50,0.7)',
      trigger: 'axis',
      confine: true,
      axisPointer: {
        type: 'shadow',
      },
      position: 'top',
      formatter: generateTooltipText,
      textStyle: {
        color: 'white',
        fontSize: 20,
        fontWeight: 300,
        textAlign: 'center',
        align: 'center',
      },
    },
    series: {
      name: legendTitle,
      type: 'bar',
      barWidth: '80%',
      data: data.map(el => ({
        name: el.name,
        value: el.value,
        itemStyle: el.name === selected ? {
          color: new echarts.graphic.LinearGradient(
            1, 0, 0, 0,
            [{ offset: 0, color: '#0054A3' }, { offset: 1, color: '#003F7A' }],
          ),
        } : {
          normal: {
            color: new echarts.graphic.LinearGradient(
              1, 0, 0, 0,
              [{ offset: 0, color: '#38526B' }, { offset: 1, color: '#102131' }],
            ),
          },
          emphasis: {
            color: new echarts.graphic.LinearGradient(
              1, 0, 0, 0,
              [{ offset: 0, color: '#1F3E59' }, { offset: 1, color: '#4F718C' }],
            ),
          },
        },
      })),
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            1, 0, 0, 0,
            [{ offset: 0, color: '#38526B' }, { offset: 1, color: '#102131' }],
          ),
        },
      },
    },
  };

  return (
    <ReactEcharts
      option={options}
      notMerge
      theme="light"
      style={{ left: '2%', width: '96%', height: '100%' }}
      onEvents={onEvents}
    />
  );
};

FilteredBarChart.defaultProps = {
  legendTitle: '',
  onEvents: {},
  selected: null,
};
FilteredBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  legendTitle: PropTypes.string,
  unitName: PropTypes.string.isRequired,
  onEvents: PropTypes.objectOf(PropTypes.func),
  selected: PropTypes.string,
};

export default FilteredBarChart;
